import React, { memo } from 'react'
import classNames from 'classnames'
import { Button } from 'transfix-ui/components/Button'
import { INavigationRoute } from 'transfix-ui/components/NavigationBar/types'
import NavigationMobileItem from 'transfix-ui/components/NavigationMobileItem'
import { makeStyles } from 'transfix-ui/core'
import ProfileItem from './ProfileItem'

interface IMenuProps {
  /**
   * @example [{ name: 'Home', location: 'home' }]
   */
  routes: INavigationRoute[]
  className?: string
  onClose: () => void
}

const useMenuStyles = makeStyles(theme => ({
  root: {
    margin: 0,
    padding: 0,
    paddingBottom: theme.spacing(20),
    display: 'flex',
    flexWrap: 'wrap',
  },
  buttonContainer: {
    width: '100%',
    padding: theme.spacing(2),
    display: 'flex',
    gap: theme.spacing(1),

    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  largeButton: {
    flex: '1 1 100%',
    width: '100%',
  },
  profileItemContainer: {
    width: '100%',
    padding: 0,
  },
}))

const MobileMenu = memo<IMenuProps>(({ routes = [], className: classNameProp, onClose }) => {
  const classes = useMenuStyles()
  const className = classNames(classes.root, classNameProp)
  const linkRoutes = routes.filter(({ type = 'link' }) => ['link', 'avatar'].includes(type))
  const buttonRoutes = routes.filter(({ type = 'link' }) => ['button'].includes(type))
  return (
    <ul data-test='MobileMenu' className={className} id='MobileMenu'>
      <li className={classes.profileItemContainer}>
        <ProfileItem />
      </li>
      <li className={classes.buttonContainer}>
        {buttonRoutes.map(route => {
          const { ButtonProps, location, name } = route || {}
          const { color } = ButtonProps || {}
          const buttonClassName = classNames({ [classes.largeButton]: color === 'primary' })
          const clickHandler = () => {
            window.location.href = location
            onClose()
          }
          return (
            <Button {...ButtonProps} onClick={clickHandler} key={name} className={buttonClassName}>
              {name}
            </Button>
          )
        })}
      </li>
      {linkRoutes.map(route => (
        <NavigationMobileItem route={route} key={route.name} onClose={onClose} />
      ))}
    </ul>
  )
})

export default MobileMenu
